/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Content types for playback scenarios.
 * Used to determine which metadata model, session impl, and playback flow to use.
 */
export enum PlaybackContentType {
  /**
   * Live linear TV content.
   */
  LIVE = "LIVE",

  /**
   * Live NDVR (Network DVR) content - viewing a recording that is still being recorded.
   */
  NDVR_LIVE = "NDVR_LIVE",

  /**
   * Completed NDVR recording playback.
   */
  NDVR_RECORDED = "NDVR_RECORDED",

  /**
   * Start Over playback from the beginning of the program.
   */
  STARTOVER_BEGINNING = "STARTOVER_BEGINNING",

  /**
   * Start Over playback from a resumed position.
   */
  STARTOVER_RESUME = "STARTOVER_RESUME",

  /**
   * Catch Up playback from the beginning of the program.
   */
  CATCHUP_BEGINNING = "CATCHUP_BEGINNING",

  /**
   * Catch Up playback from a resumed position.
   */
  CATCHUP_RESUME = "CATCHUP_RESUME",

  /**
   * Video On Demand content.
   */
  VOD = "VOD"
}
